var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencilColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Outline / Interface / Edit-alt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 17.5,
    viewBox: "0 0 16.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.75 14.521a.75.75 0 0 1-.726-.94l1-3.829a.763.763 0 0 1 .2-.34L10.412.22a.75.75 0 0 1 1.06 0L14.3 3.048a.749.749 0 0 1 0 1.06L5.108 13.3a.739.739 0 0 1-.34.2l-3.828 1a.748.748 0 0 1-.19.021zm10.192-12.71-8.517 8.517-.625 2.394 2.392-.622 8.518-8.522-1.768-1.767z",
    transform: "translate(.414)",
    style: {
      fill: "#8c8d99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 0a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5z",
    transform: "translate(0 16)",
    style: {
      fill: "#1bc47d"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilColored);
export default __webpack_public_path__ + "static/media/edit-pencil-colored.0e7d026365004c8d93baaf6c4167044d.svg";
export { ForwardRef as ReactComponent };